import { AJAX_TIMEOUT_MESSAGE, withOverlayLoader } from '../helpers.js';
import { setBack } from '../shared/nav-buttons.js';
import { initAuthOtpPaymentModal } from './auth-otp-payment-modal.js';
import { cleanupBootstrapModalBody } from '../shared/bootstrap-modal-cleanup.js';
import { checkoutIntentFor } from '../shared/checkout-intent.js';
import { chargeWentThrough } from '../shared/charge-went-through.js';
import { htmlShowsPaymentReceivedPage } from '../shared/payment-received-page.js';
import { applyChargeSuccess } from '../shared/apply-charge-success.js';
import { openIndexPage } from './member-open-index-page.js';
import { showAlertMsg } from './member-show-alert-msg.js';
import { setPaymentPayButtonDisabled } from '../shared/payment-pay-button.js';

const LISTENERS_BOUND = Symbol.for('kiosk.userSavedPayment.listenersBound');

export function initUserSavedPaymentEntry() {
    if (document.getElementById('auth-otp-payment-modal-config')) {
        initAuthOtpPaymentModal();
    }

    function otpModal() {
        return $('#payAuthModal');
    }

    const NEXT_BTN_NS = 'click.userSavedPayment';
    const NEXT_BTN_SELECTOR = '.user-saved-payment-next-btn';
    const CONFIG_SCRIPT_ID = 'user-saved-payment-config';

    function getCsrfToken() {
        const meta = document.querySelector('meta[name="csrf-token"]');
        return meta ? meta.getAttribute('content') : '';
    }

    function readConfig() {
        const el = document.getElementById(CONFIG_SCRIPT_ID);
        if (!el) return null;
        try {
            return JSON.parse(el.textContent || '');
        } catch (err) {
            console.error('user-saved-payment: invalid user-saved-payment-config JSON', err);
            return null;
        }
    }

    function buildPaymentData(config) {
        const savedCcId = $('#saved_cc').val();
        const data = {
            congregation_name: config.congregationName,
            payment_type: 'saved',
            process_type: 'token',
            cc_id: savedCcId,
            user_id: config.userId,
            donation_amount: config.donationAmount,
            donation_type: config.donationType,
            campaign_id: config.campaignId,
            charity_amount: config.charityAmount,
            charity_id: config.charityId,
            cover_surcharge: config.coverSurcharge,
            checkout_intent: checkoutIntentFor(otpModal()),
            _token: getCsrfToken()
        };
        if (config.frequencyId > 0) {
            data.frequency_id = config.frequencyId;
            data.duration = config.duration;
            data.pledge_start_date = config.pledgeStartDate;
            data.installment_amount = config.installmentAmount;
        }
        return data;
    }

    function openOtpModal(savedCcId) {
        const $modal = otpModal();
        $modal.find('#cc_id').val(savedCcId);
        $modal
            .one('shown.bs.modal', () => $('#otp').focus())
            .modal('show');
    }

    function applyPaymentResponse(response) {
        try {
            if (!htmlShowsPaymentReceivedPage(response.page_info)) {
                if (response.error && !response.payment_processed) {
                    showAlertMsg(response.error, 'danger');
                } else if (response.message && !response.payment_processed) {
                    showAlertMsg(response.message);
                }
            }
        } catch (err) {
            console.error('user-saved-payment: post-charge alert failed', err);
        }
        applyChargeSuccess(response);
    }

    function sendOtpOpenModal(config) {
        const savedCcId = $('#saved_cc').val();
        const useOtp = config.cardsOtp[savedCcId] === '1';

        withOverlayLoader({
            url: config.otpUrl,
            type: 'POST',
            data: buildPaymentData(config),
            success: (response) => {
                if (useOtp && response.success && !response.payment_processed) {
                    setPaymentPayButtonDisabled(false);
                    openOtpModal(savedCcId);
                    return;
                }
                if (chargeWentThrough(response)) {
                    applyPaymentResponse(response);
                    return;
                }
                setPaymentPayButtonDisabled(false);
                showAlertMsg(response.error, 'danger');
            },
            error: () => {
                setPaymentPayButtonDisabled(false);
                showAlertMsg(AJAX_TIMEOUT_MESSAGE, 'danger');
                openIndexPage();
            }
        });
    }

    function initUserSavedPaymentPage() {
        const config = readConfig();
        if (!config) return;

        if (config.campaignBackLink) {
            setBack(true);
        }

        cleanupBootstrapModalBody();
    }

    if (!globalThis[LISTENERS_BOUND]) {
        globalThis[LISTENERS_BOUND] = true;

        $(document)
            .off(NEXT_BTN_NS, NEXT_BTN_SELECTOR)
            .on(NEXT_BTN_NS, NEXT_BTN_SELECTOR, (e) => {
                e.preventDefault();
                const config = readConfig();
                if (config) sendOtpOpenModal(config);
            });

        document.addEventListener('saved-card:pay', () => {
            const config = readConfig();
            if (!config) {
                setPaymentPayButtonDisabled(false);
                return;
            }
            sendOtpOpenModal(config);
        });
    }

    if (readConfig()) initUserSavedPaymentPage();
}
